import script from "./OrganizationContractClinicianPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationContractClinicianPanel.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationContractClinicianPanel.vue?vue&type=style&index=0&id=5af6d7d7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af6d7d7"]])

export default __exports__